module.exports = __webpack_public_path__ + "static/img/snow.b5016fb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/snow.jpeg
// module id = ysGV
// module chunks = 1